import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material';
import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	PremiumReportData,
	withPremiumReportContext,
} from '../../../context/premiumReport';
import { PRIMARY_BUTTON_STYLE } from '../../../data/constants';

interface Props {
	authData: AuthData;
	premiumReportData: PremiumReportData;
}

const CancelReplaceModal = ({ premiumReportData }: Props) => {
	const { premiumReportUpdateReq, setReplaceMode, setPremiumReportUpdateReq } =
		premiumReportData;
	const [open, setOpen] = React.useState(false);

	const handleOpen = () => {
		if (
			!!premiumReportUpdateReq.fieldValues ||
			(!!premiumReportUpdateReq.fieldGroups &&
				premiumReportUpdateReq.fieldGroups.length)
		) {
			setOpen(true);
		} else {
			cancelReplace();
		}
	};

	const handleClose = () => {
		setOpen(false);
	};

	const cancelReplace = () => {
		setReplaceMode(false);
		setPremiumReportUpdateReq({});
	};

	return (
		<>
			<Button color='primary' variant='contained' onClick={handleOpen}>
				Cancel
			</Button>
			<Dialog
				fullWidth
				open={open}
				onClose={handleClose}
				aria-labelledby='cancel-replace-title'
			>
				<DialogTitle id='cancel-replace-title'>Cancel Replacement</DialogTitle>
				<DialogContent>
					<Typography>
						{
							"Are you sure you want to cancel this replacement report? Any changes you've made will be lost."
						}
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={cancelReplace}
						color='primary'
						style={PRIMARY_BUTTON_STYLE}
						variant='contained'
					>
						Yes
					</Button>
					<Button
						onClick={handleClose}
						color='primary'
						style={PRIMARY_BUTTON_STYLE}
						variant='contained'
					>
						No
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default withPremiumReportContext(CancelReplaceModal);
